import { getAccountInfo, updateAccountInfoBasic, updateAccountInfoBusiness } from 'APIs/accountInfo'
import { hideOverlay, showModalMessage, showOverlay } from 'Modules/store/actions'
import { call, put, takeLatest } from 'redux-saga/effects'
import { REQUEST, SUCCESS } from 'Stores'
import { GET_ACCOUNT_INFO, UPDATE_ACCOUNT_INFO_BASIC, UPDATE_ACCOUNT_INFO_BUSINESS } from './constants'

export function* getAccountInfoSaga({ payload }) {
  try {
    yield put(showOverlay())
    const data = yield call(getAccountInfo, payload.userId)
    yield put({
      type: SUCCESS(GET_ACCOUNT_INFO),
      payload: {
        accountInfo: data.result
      }
    })
    yield put(hideOverlay())
  } catch (error) {
    yield put(hideOverlay())
    yield put(showModalMessage({ message: error }))
  }
}

export function* updateAccountBasicSaga({ payload }) {
  try {
    const { formData, userId } = payload
    yield put(showOverlay())
    yield call(updateAccountInfoBasic, formData, userId)
    const data = yield call(getAccountInfo, userId)
    yield put({
      type: SUCCESS(GET_ACCOUNT_INFO),
      payload: {
        accountInfo: data.result
      }
    })
    yield put(hideOverlay())
    yield put(showModalMessage({ message: 'Edit success', type: 'success' }))
  } catch (error) {
    yield put(hideOverlay())
    yield put(showModalMessage({ message: error }))
  }
}

export function* updateAccountBusinessSaga({ payload }) {
  try {
    const { formData, userId } = payload
    yield put(showOverlay())
    yield call(updateAccountInfoBusiness, formData, userId)
    const data = yield call(getAccountInfo, userId)
    yield put({
      type: SUCCESS(GET_ACCOUNT_INFO),
      payload: {
        accountInfo: data.result
      }
    })
    yield put(hideOverlay())
    yield put(showModalMessage({ message: 'Edit success', type: 'success' }))
  } catch (error) {
    yield put(hideOverlay())
    yield put(showModalMessage({ message: error }))
  }
}

export default function* authSaga() {
  yield takeLatest(REQUEST(GET_ACCOUNT_INFO), getAccountInfoSaga)
  yield takeLatest(REQUEST(UPDATE_ACCOUNT_INFO_BASIC), updateAccountBasicSaga)
  yield takeLatest(REQUEST(UPDATE_ACCOUNT_INFO_BUSINESS), updateAccountBusinessSaga)
}
